module.exports = __webpack_public_path__ + "static/media/menu-icon-badge-locked.05cb5268.png";